import { LitElement, html, unsafeCSS, CSSResult } from 'lit';
import { property } from 'lit/decorators.js';
import { literal } from 'lit/static-html.js';
import { C11nPrefix, C11nPrefixLiteral } from 'virtual:c11n-prefix';
import slotStyles from './icon-button.slot.scss?inline';
import styles from './icon-button.scss?inline';
import { appendStylesheet, c11nElement } from '../core';

@c11nElement()
export class IconButtonComponent extends LitElement {
  static selector = `${C11nPrefix}-icon-button`;
  static literal = literal`${C11nPrefixLiteral}-icon-button`;
  static override styles: CSSResult = unsafeCSS(styles);

  @property({ attribute: 'c11n-web-icon-button', type: Boolean, reflect: true })
  readonly _c11n_web_icon_button: boolean = true;

  override connectedCallback(): void {
    super.connectedCallback();
    this.appendStyles();
  }

  appendStyles() {
    const slotStylesheet: string = slotStyles.toString()
      .replaceAll(/\bc11n-web-icon-button\b/g, this.tagName.toLowerCase());
    appendStylesheet({ 
      target: this, 
      styles: slotStylesheet, 
      name: `${this.tagName.toLowerCase()}-slot`
    });
  }

  override render() {
    return html`
      <slot></slot>
    `;
  }
}
export const C11nIconButton = IconButtonComponent.selector;
export const C11nIconButtonLiteral = IconButtonComponent.literal;
